<!-- Breadcrumb Content -->
<p-scrollPanel #scrollPanel
               [style]="{ width: width, height: height }">
  <ng-content></ng-content>
</p-scrollPanel>
